export default {
  logout: "Logout",
  login: "Login",
  loginSuccess: "Login Success",
  logoutSuccess: "Logout Success",
  noData: "No Data",
  action: "Action",
  add: "Add{val}",
  del: "Delete",
  edit: "Edit{val}",
  search: "Search",
  sort: "Sort",
  pleaseSelect: "Select {val}",
  pleaseEnter: "Enter {val}",
  yes: "Yes",
  no: "No",
  service: "L2 CS Admin",
  update: "Update",
  changePassword: "Change Password",
  changeUploadError: "Invalid image format",
  minLength: "Min length: {val}",
  resetPasswords: "Reset Password",
  rememberPassword: "Remember Password",
  send: "Send",
  copySuccess: "Copy Success",
  copyError: "Copy Error",
  inputUsername: "Please enter your username",
  inputPassword: "Please enter your password",
  connecting: "Loading...",
  password: "password",
  online: "Online",
  offline: "Offline",
  busy: "Busy",
  light: "Light",
  dark: "Dark",
  onlineStatus: "Online Status",
  selectAgentToggleStatus: "Select Agent Online Status",
  time: {
    hour: "h",
    minute: "m",
    second: "s",
  },
};
